<!-- <h4>{{titleCard}}</h4>
<mat-dialog-content class="mat-typography">

    <form [formGroup]="reusableForm">

        <div fxLayout="row wrap" fxLayoutAlign="space-between center">

            <div fxFlex.md="100" fxFlex.lg="100" fxFlex.sm="100" class="p-10">
                <mat-form-field appearance="outline">
                    <mat-label>Nombre</mat-label>
                    <input matInput formControlName="name" placeholder="Placeholder">
                </mat-form-field>
            </div>

            <div fxFlex.md="100" fxFlex.lg="100" fxFlex.sm="100" class="p-10" [hidden]="type !== 'normas'">
                <mat-form-field appearance="outline">
                    <mat-label>Instrumento</mat-label>
                    <input matInput formControlName="instrumentGuid" placeholder="Placeholder">
                </mat-form-field>
            </div>

            <div fxFlex.md="100" fxFlex.lg="100" fxFlex.sm="100" class="p-10" [hidden]="type !== 'patrones'">
                <mat-form-field appearance="outline">
                    <mat-label>Fecha de vencimiento</mat-label>
                    <input matInput formControlName="dueDate" placeholder="Placeholder">
                </mat-form-field>
            </div>

            <div fxFlex.md="100" fxFlex.lg="100" fxFlex.sm="100" class="p-10" [hidden]="type !== 'patrones'">
                <mat-form-field appearance="outline">
                    <mat-label>Trazabilidad</mat-label>
                    <input matInput formControlName="traceability" placeholder="Placeholder">
                </mat-form-field>
            </div>

            <div fxFlex.md="100" fxFlex.lg="100" fxFlex.sm="100" class="p-10" [hidden]="type !== 'magnitud'">
                <mat-form-field appearance="outline">
                    <mat-label>Magnitud</mat-label>
                    <input matInput formControlName="magnitudGuid" placeholder="Placeholder">
                </mat-form-field>
            </div>

        </div>

        <div fxLayout="row" fxLayoutAlign="space-around center">

            <button mat-stroked-button color="warn">Cancelar</button>

            <button mat-stroked-button color="success">Guardar</button>

        </div>

    </form>

</mat-dialog-content> -->

<div *ngIf="data?.folio; else simpleTitle" class="dialog-header">
  <h4 class="title">{{ titleCard }}</h4>

  <div class="folio-box">
    <ng-container *ngIf="!editingFolio">
      <span *ngIf="!data.modEdit">
        {{ data.folio }}
      </span>

      <span *ngIf="data.modEdit"> S-{{ data.folio }} </span>

      <button
        *ngIf="data.modEdit"
        mat-icon-button
        type="button"
        class="edit-folio-button"
        (click)="enableFolioEdit()"
      >
        <mat-icon>edit</mat-icon>
      </button>
    </ng-container>

    <div class="folio-edit-container" *ngIf="editingFolio">
      <span class="folio-prefix"> S- </span>

      <input class="folio-inline-input" type="number" [(ngModel)]="newFolio" />

      <button
        mat-icon-button
        color="primary"
        type="button"
        (click)="saveFolio()"
      >
        <mat-icon>check</mat-icon>
      </button>

      <button
        mat-icon-button
        color="warn"
        type="button"
        (click)="cancelFolioEdit()"
      >
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>
</div>

<ng-template #simpleTitle>
  <h4>{{ titleCard }}</h4>
</ng-template>

<mat-dialog-content class="mat-typography">
  <app-dynamic-form
    [model]="model"
    [canSave]="isSuperAdminVentas"
    (submitted)="formSubmitted($event)"
  ></app-dynamic-form>
</mat-dialog-content>
